import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';

import { PaymentQrMerchantsRepository } from '@app/domain/ports/payment-qr-merchants.repository';
import { PolipayPaymentsRepository } from '@app/domain/ports/polipay-payments.repository';
import type { QrMerchantCandidatePage, QrMerchantQuery } from '@app/domain/models/payments-qr/qr-merchant.model';
import { PaymentQrError } from '@app/domain/models/payments-qr/payment-qr.error';
import { toPaymentQrError } from '@app/data/mappers/payments/payment-qr.mapper';
import { toQrMerchantCandidatePage } from '@app/data/mappers/payments/qr-merchant.mapper';

/**
 * Implementa el port chico del campo "Comercio" delegando en
 * `PolipayPaymentsRepository.listCompanies` (`GET /api/v1/payments/companies/`).
 *
 * No es una fuente de datos: es una traducción sobre un port que YA se resuelve
 * a mock o remote por `environment.useMocks` en `app.config`. Por eso no tiene
 * mock propio — duplicaría `MOCK_COMPANIES` y los dos mocks divergirían.
 *
 * Errores: se convierten con `toPaymentQrError`, que clasifica y NO copia el
 * texto del backend (RS14). Un fallo que no sea HTTP sale como `unknown`.
 */
@Injectable()
export class PaymentQrMerchantsAdapter extends PaymentQrMerchantsRepository {
  private readonly payments = inject(PolipayPaymentsRepository);

  listCandidates(query: QrMerchantQuery): Observable<QrMerchantCandidatePage> {
    // Solo los tres filtros de RS2: sin `search` ni `offset`.
    return this.payments
      .listCompanies({ is_active: query.isActive, cobra_a: query.cobraA, limit: query.limit })
      .pipe(
        map(toQrMerchantCandidatePage),
        catchError((error: unknown) =>
          throwError(() =>
            error instanceof HttpErrorResponse
              ? toPaymentQrError(error.status, error.error)
              : new PaymentQrError('unknown', 0, null),
          ),
        ),
      );
  }
}
